import { notifications } from '@mantine/notifications';
import { getChequeGirosKey, useCreateChequeGiro } from 'api-hooks/cheque-giro';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import { queryClient } from 'common/repositories/query-client';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';

import ChequeGiroForm from './components/form';

export default function ChequeGiroCreate() {
  const { navigate, back } = useNavigation();
  const createMutation = useCreateChequeGiro();
  const permission = useGetCrudPermission('cheque-giros');

  return (
    <ChequeGiroForm
      saveMutation={createMutation}
      onSubmit={async (input) => {
        const result = await createMutation.mutateAsync(input);
        queryClient.refetchQueries(getChequeGirosKey());
        const prevPath = PreviousNavigation.get();
        if (prevPath) {
          PreviousNavigation.remove();
          back();
        } else if (permission.view) {
          navigate(NavigationRoutes.ChequeGirosView, {
            id: result.data?.id,
          });
        }
        notifications.show({ message: result?.message, color: 'green' });
        return result.data;
      }}
    />
  );
}
